import { Dialog, PdfViewer } from "@sveabank/cc-common";
import BankIdSigning from "./bankid-signing";

type Props = {
	isModalOpen: boolean;
	setOpen: (isOpen: boolean) => void;
	signAction: () => Promise<void>;
	isSigning: boolean;
	pdfData: string;
	title: string;
};

const AgreementSigningModal = ({
	isModalOpen,
	setOpen,
	title,
	signAction,
	pdfData,
	isSigning,
}: Props) => (
	<Dialog isOpen={isModalOpen} setOpen={setOpen} size="full" withPadding={false} heading={title}>
		<Dialog.Content>
			<PdfViewer pdfData={pdfData} />
		</Dialog.Content>
		<Dialog.Footer>
			<BankIdSigning signAction={signAction} isSigning={isSigning} />
		</Dialog.Footer>
	</Dialog>
);

export default AgreementSigningModal;
